const parseExtraTax = (price, decimals) => {
  let parsedPrice = price;

  if (price && !price.length) {
    parsedPrice = '';
  } else if (price.split('.')[1]?.length > decimals) {
    parsedPrice = (price.substr(0, price.indexOf('.')) + price.substr(price.indexOf('.'), decimals + 1));
  }

  if (parsedPrice > 0) return Math.abs(parsedPrice);

  return +parsedPrice;
};

export default parseExtraTax;
